import { NAME as moduleName } from './name';
const NAME = moduleName.toUpperCase();
export const CONFIRM_DIALOG = `${NAME}/CONFIRM_DIALOG`;
